<template>
  <v-menu
    :close-on-content-click="false"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        text
        color="primary"
        v-on="on"
      >
        <v-badge
          v-model="appliedFilters"
          overlap
          color="accent"
        >
          <span slot="badge">{{ appliedFilters }}</span>
          <v-icon>filter_list</v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-card>
      <v-card-title primary-title>
        <div class="title">
          Project Filter
        </div>
        <v-btn
          text
          @click="clearFilter"
        >
          Clear
          <span
            v-show="appliedFilters > 0"
            class="ml-2"
          >
            ({{ appliedFilters }})
          </span>
        </v-btn>
      </v-card-title>

      <v-container
        fluid
        grid-list-lg
      >
        <v-layout
          row
          wrap
        >
          <!-- Custom Properties -->
          <v-flex
            v-for="customProp in customProperties('project')"
            :key="`custom-prop-${customProp.name}`"
            xs12
            sm6
            md4
          >
            <component
              :is="getCustomFieldType(customProp.type)"
              v-model="filters[customProp.name]"
              :label="customProp.name"
              :items="customProp.values"
              :hint="customProp.description"
              persistent-hint
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
import { VSwitch, VSelect, VTextField } from 'vuetify/lib'
import { mapGetters } from 'vuex'

const CUSTOM_FIELDS_BY_TYPE = {
  boolean: 'v-switch',
  enum: 'v-select',
  number: 'v-text-field',
  string: 'v-text-field'
}

export default {
  components: {
    VSwitch,
    VSelect,
    VTextField
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return { }
      },
      required: true
    }
  },
  data () {
    return {
      showFilters: false
    }
  },
  computed: {
    ...mapGetters('organizations', [ 'customProperties' ]),
    filters: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    appliedFilters: {
      get () {
        let n = 0
        for (let id in this.value) {
          const f = this.value[id]
          n += !(f === null ||
            f === undefined ||
            f.length === 0)
        }
        return n
      },
      set () {}
    }
  },
  methods: {
    onChangeFilter () {
      this.$emit('change')
    },
    clearFilter () {
      this.filters = {}
    },
    getCustomFieldType (type) {
      return CUSTOM_FIELDS_BY_TYPE[type]
    }
  }
}
</script>
